<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { avatarGroupProps } from './avatar-group'

defineOptions({
  name: 'VsAvatarGroup',
})

defineProps(avatarGroupProps)

// init here
</script>
